/** Shared money formatting for admin detail surfaces: `$1,234.50`. */
export function money(n: number | null | undefined): string {
  return `$${(Number(n) || 0).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

/**
 * Percent of booked revenue that's been collected, rounded to a whole percent.
 * Returns null when nothing has been booked yet, so callers can omit the line
 * rather than render a meaningless 0%.
 */
export function collectedPct(collected: number, grossBooked: number): number | null {
  if (!grossBooked || grossBooked <= 0) return null;
  return Math.round((collected / grossBooked) * 100);
}
